
import { Component, Vue } from "vue-property-decorator";
import { SMCases } from "@/store";
import { TCase_Dependant_Applicant, TCase_Main_Applicant } from "@/models/cases";
import { API_ROUTES } from "@/utils/API";
import {
  SERVICE_STATUS,
  OA_STATUS,
  SERVICE_STEPS,
  TYPE_SERVICE,
  SERVICE_ALIASES,
  COS_SKILLED_WORKER_INSIDE_SERVICE,
  COS_SKILLED_WORKER_SERVICE,
  DEPENDANT_INSIDE_SERVICE_TYPE,
  DEPENDANT_INSIDE_SERVICE,
} from "@/constants/services";

const NONE_LIST_TYPE = "none";

@Component({
  components: {
    Hello: () => import("./Highlight/Hello.vue"),
    OnExpertReview: () => import("./Highlight/OnExpertReview.vue"),
    Payment: () => import("./Highlight/Payment.vue"),
    CosCreation: () => import("./Highlight/CosCreation.vue"),
    AdditionalInfo: () => import("./Highlight/AdditionalInfo.vue"),
    ApplicationSubmission: () => import("./Highlight/ApplicationSubmission.vue"),
    VisaDecision: () => import("./Highlight/VisaDecision.vue"),
    ApprovedByHO: () => import("./Highlight/ApprovedByHO.vue"),
    RejectedByHO: () => import("./Highlight/RejectedByHO.vue"),
    AdditionalIDataAndDocuments: () => import("./Highlight/AdditionalIDataAndDocuments.vue"),
    IdChecks: () => import("./Highlight/IdChecks.vue"),
    FinalExpertReview: () => import("./Highlight/FinalExpertReview.vue"),
  },
})
export default class DependantHighlight extends Vue {
  statuses = { ...SERVICE_STATUS, ...OA_STATUS };
  serviceSteps = SERVICE_STEPS;

  get caseId(): number {
    return Number(this.$route.params.id ?? 0);
  }

  init = false;

  get status() {
    return SMCases.caseStatus;
  }

  get onlineApplicationStatus() {
    return SMCases.onlineApplicationStatus;
  }

  get isApprovedByHo() {
    const { status, statuses, onlineApplicationStatus } = this;

    return status === statuses.complete && onlineApplicationStatus === statuses.approved_by_ho;
  }

  get isRejectedByHo() {
    const { status, statuses, onlineApplicationStatus } = this;

    return status === statuses.complete && onlineApplicationStatus === statuses.rejected_by_ho;
  }

  get stepName() {
    return SMCases.caseStepName;
  }

  caseHasTask = false;

  mainApplicant: TCase_Main_Applicant = {
    first_name: "",
    last_name: "",
    job_title: "",
  };

  dependantApplicant?: TCase_Dependant_Applicant = {
    first_name: "",
    last_name: "",
    title: "",
  };

  get jobTitle() {
    return this.mainApplicant.job_title;
  }

  get name() {
    const dependantCaseType = [DEPENDANT_INSIDE_SERVICE_TYPE].includes(SMCases.caseType);

    if (dependantCaseType) {
      if (!this.dependantApplicant) return "";
    } else {
      if (!this.mainApplicant) return "";
    }

    const { first_name, last_name } = dependantCaseType
      ? this.dependantApplicant
      : this.mainApplicant;

    return first_name && last_name ? `${first_name} ${last_name}` : "";
  }

  get listType() {
    const { caseType } = this;

    if (
      [
        COS_SKILLED_WORKER_SERVICE,
        COS_SKILLED_WORKER_INSIDE_SERVICE,
        DEPENDANT_INSIDE_SERVICE,
      ].includes(caseType)
    ) {
      return NONE_LIST_TYPE;
    }

    return null;
  }

  get commonWidgetProps() {
    const { jobTitle, name, caseType, listType, getDependantVisaEnable } = this;

    return {
      jobTitle,
      name,
      caseType,
      listType,
      getDependantVisaEnable,
    };
  }

  risk = "";

  async getCase() {
    try {
      const { data } = await this.axios.get(API_ROUTES.CASE_ID(this.caseId));

      if (!data) return;

      SMCases.setCaseStatus(data.status);

      SMCases.setCase(data);

      this.risk = data.final_decision;

      this.caseHasTask = data.has_task;
      SMCases.setHasTasks(data.has_task);

      this.mainApplicant = data.main_applicant;
      SMCases.setMainApplicant(data.main_applicant);

      this.dependantApplicant = data.dependant_applicant;
      SMCases.setDependantApplicant(data.main_applicant);
    } finally {
      this.init = true;
    }
  }

  get caseType() {
    let output = "";

    const aliases: TYPE_SERVICE = SERVICE_ALIASES;

    Object.keys(aliases).forEach((key: string) => {
      if (aliases[key] === SMCases.caseAlias) output = key;
    });

    return output;
  }

  get getDependantVisaEnable() {
    const service = (SMCases.case as unknown) as { can_start_dependant_case: boolean };

    return service.can_start_dependant_case === true;
  }

  mounted() {
    if (!this.init) this.getCase();
  }

  activated() {
    // NOTE: This approach helps us to refresh "tasks";
    // if (!this.init) this.getCase();
  }
}
